import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const RED = '#b91d47', RED_D = '#8f1538', INK = '#1c1c28', GREY = '#7a7a8c';

export default function AppAddresses() {
  const navigate = useNavigate();
  const [addrs, setAddrs] = useState([]);
  const [adding, setAdding] = useState(false);
  const [label, setLabel] = useState('Home');
  const [text, setText] = useState('');

  useEffect(() => {
    try { setAddrs(JSON.parse(localStorage.getItem('savedAddresses') || '[]')); } catch (e) { setAddrs([]); }
  }, []);

  const save = () => {
    if (!text.trim()) { toast.error('Please enter address'); return; }
    const next = [...addrs, { label, text: text.trim() }];
    setAddrs(next);
    localStorage.setItem('savedAddresses', JSON.stringify(next));
    setText(''); setAdding(false);
    toast.success('Address saved');
  };

  const remove = (i) => {
    const next = addrs.filter((_, idx) => idx !== i);
    setAddrs(next);
    localStorage.setItem('savedAddresses', JSON.stringify(next));
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fb', maxWidth: 480, margin: '0 auto' }}>
      <div style={{ background: `linear-gradient(135deg,${RED},${RED_D})`, color: '#fff', padding: '20px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <span onClick={() => navigate('/app/profile')} style={{ fontSize: 24, cursor: 'pointer' }}>‹</span>
        <div style={{ fontSize: 18, fontWeight: 700 }}>Saved Addresses</div>
      </div>
      <div style={{ padding: 16 }}>
        {addrs.map((a, i) => (
          <div key={i} style={{ background: '#fff', borderRadius: 14, padding: 16, marginBottom: 12, display: 'flex', gap: 12, alignItems: 'flex-start', boxShadow: '0 2px 8px rgba(28,28,40,.05)' }}>
            <span style={{ fontSize: 20 }}>{a.label === 'Home' ? '🏠' : a.label === 'Work' ? '🏢' : '📍'}</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: INK }}>{a.label}</div>
              <div style={{ fontSize: 13, color: GREY, marginTop: 3 }}>{a.text}</div>
            </div>
            <span onClick={() => remove(i)} style={{ color: '#dc2626', cursor: 'pointer', fontSize: 18 }}>🗑</span>
          </div>
        ))}

        {adding ? (
          <div style={{ background: '#fff', borderRadius: 14, padding: 16, boxShadow: '0 2px 8px rgba(28,28,40,.05)' }}>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              {['Home', 'Work', 'Other'].map(l => (
                <button key={l} onClick={() => setLabel(l)} style={{ flex: 1, padding: 10, borderRadius: 10, border: label === l ? `1.5px solid ${RED}` : '1.5px solid #f0f0f4', background: label === l ? '#fdf2f5' : '#fff', color: label === l ? RED : INK, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>{l}</button>
              ))}
            </div>
            <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Enter full address" rows={3}
              style={{ width: '100%', border: '1.5px solid #f0f0f4', borderRadius: 12, padding: 12, fontSize: 14, outline: 'none', boxSizing: 'border-box', resize: 'none', fontFamily: 'inherit' }} />
            <button onClick={save} style={{ background: RED, color: '#fff', border: 'none', borderRadius: 12, padding: 14, fontWeight: 700, width: '100%', marginTop: 10, cursor: 'pointer' }}>Save Address</button>
          </div>
        ) : (
          <button onClick={() => setAdding(true)} style={{ background: '#fff', color: RED, border: `1.5px dashed ${RED}`, borderRadius: 12, padding: 14, fontWeight: 700, width: '100%', cursor: 'pointer' }}>+ Add New Address</button>
        )}
      </div>
    </div>
  );
}
